import i18n from '@/lang/i18n';

export const TARGET_CATEGORY_OPERATION_OFFICE = 'operationOffice'
export const TARGET_CATEGORY_DEVICE_TYPE = 'deviceType'
export const TARGET_CATEGORY_FIRMWARE = 'firmware'

export const TARGET_CATEGORYS = [
  {title: i18n.global.t('pages.firmwareBulkUpdate.operationOffice'), value: TARGET_CATEGORY_OPERATION_OFFICE},
  {title: i18n.global.t('pages.firmwareBulkUpdate.deviceType'), value: TARGET_CATEGORY_DEVICE_TYPE},
  {title: i18n.global.t('pages.firmwareBulkUpdate.firmware'), value: TARGET_CATEGORY_FIRMWARE}
]

export const FIRMWARE_BULK_UPDATE_SETTINGS_TABLE_HEADERS = [
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.id'),
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.applyDate'),
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.firmwareVersion'),
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.nunberOfApplyDevices'),
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.numberOfRemovedDevices'),
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.updatedAt'),
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.updatedBy'),
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.detailBtn'),
  i18n.global.t('pages.firmwareBulkUpdate.firmwareBlukUpdateSettings.tableHeader.deleteBtn'),
]

export const REMOVE_DEVICE_TABLE_HEADEERS = [
  i18n.global.t('pages.firmwareBulkUpdate.removeDeviceSearch.tableHeader.operationOffice'),
  i18n.global.t('pages.firmwareBulkUpdate.removeDeviceSearch.tableHeader.deviceId'),
  i18n.global.t('pages.firmwareBulkUpdate.removeDeviceSearch.tableHeader.vehicleNumber'),
  i18n.global.t('pages.firmwareBulkUpdate.removeDeviceSearch.tableHeader.deviceType')
]
